import { useState, useEffect } from 'react';

export const isDenominationEnabled = () => {
    const setting = localStorage.getItem('enable_cash_denomination');
    return setting === 'true';
};

export const updateDenominationSetting = (enabled) => {
    localStorage.setItem('enable_cash_denomination', enabled ? 'true' : 'false');
    window.dispatchEvent(new Event('closing_entry_setting_changed'));
    window.dispatchEvent(new Event('storage'));
};

export const isTelephoneBalanceEnabled = () => {
    const setting = localStorage.getItem('enable_telephone_balance');
    return setting === 'true';
};

export const updateTelephoneBalanceSetting = (enabled) => {
    localStorage.setItem('enable_telephone_balance', enabled ? 'true' : 'false');
    window.dispatchEvent(new Event('closing_entry_setting_changed'));
    window.dispatchEvent(new Event('storage'));
};

export const useClosingEntrySettings = () => {
    const [enableDenomination, setEnableDenomination] = useState(isDenominationEnabled());
    const [enableTelephoneBalance, setEnableTelephoneBalance] = useState(isTelephoneBalanceEnabled());

    useEffect(() => {
        const handleSettingChange = () => {
            setEnableDenomination(isDenominationEnabled());
            setEnableTelephoneBalance(isTelephoneBalanceEnabled());
        };

        window.addEventListener('closing_entry_setting_changed', handleSettingChange);
        window.addEventListener('storage', handleSettingChange);

        return () => {
            window.removeEventListener('closing_entry_setting_changed', handleSettingChange);
            window.removeEventListener('storage', handleSettingChange);
        };
    }, []);

    return { 
        enableDenomination, 
        updateDenominationSetting,
        enableTelephoneBalance,
        updateTelephoneBalanceSetting
    };
};
